export const configs = {
  authenticatedRoute: '/dashboard',
  unauthenticatedRoute: '/login',
};
